<div class="official-third-party-page" [testId]="'official-third-party-page'">
  <div class="page-topbar" [testId]="'official-third-party-topbar'">
    <div class="page-header" [testId]="'official-third-party-header'">
      <div class="page-heading">
        <h2>{{ 'official.third-party-app.title' | i18n }}</h2>
        <p>{{ 'official.third-party-app.subtitle' | i18n }}</p>
      </div>

      <div class="page-actions" [testId]="'official-third-party-header-actions'">
        <button
          nz-button
          nzType="default"
          type="button"
          class="refresh-button"
          [nzLoading]="loading"
          [disabled]="loading"
          (click)="refreshApps()"
          [testId]="'official-third-party-refresh'"
        >
          <i nz-icon nzType="reload" nzTheme="outline"></i>
          {{ 'common.refresh' | i18n }}
        </button>

        <button
          nz-button
          nzType="primary"
          type="button"
          class="create-button"
          (click)="openCreateModal()"
          [testId]="'official-third-party-create'"
          *ngIf="currentTab === 'drafts'"
        >
          <i nz-icon nzType="plus"></i>
          {{ 'official.third-party-app.create' | i18n }}
        </button>
      </div>
    </div>
  </div>

  <div class="page-scroll" [testId]="'official-third-party-scroll'">
    <nz-tabset
      class="app-tabs"
      [(nzSelectedIndex)]="activeTab"
      (nzSelectedIndexChange)="onTabChanged($event)"
      [testId]="'official-third-party-tabs'"
    >
      <nz-tab [nzTitle]="'official.third-party-app.tab.connected' | i18n" [testId]="'official-third-party-tab-connected'" />
      <!-- 暫時註釋「我的草稿」Tab，待多管理員數據隔離方案確定後重啟
      <nz-tab [nzTitle]="'official.third-party-app.tab.drafts' | i18n" [testId]="'official-third-party-tab-drafts'" />
      -->
      <nz-tab [nzTitle]="'official.third-party-app.tab.review' | i18n" [testId]="'official-third-party-tab-review'" />
    </nz-tabset>

    <div class="page-content-area">
      <div class="loading-overlay" *ngIf="loading && currentTab !== 'review'" [testId]="'official-third-party-loading-overlay'">
        <nz-spin nzSimple [nzSize]="'large'" />
        <span>{{ 'common.loading' | i18n }}</span>
      </div>
      <div class="review-list" *ngIf="currentTab === 'review'" [testId]="'official-third-party-review-list'">
        <div class="review-list-toolbar">
          <div>
            <h3>{{ 'official.third-party-app.review.queue-title' | i18n }}</h3>
            <p>{{ 'official.third-party-app.review.queue-hint' | i18n }}</p>
          </div>
          <nz-tag class="review-count-tag" [nzColor]="filteredReviewApps.length ? 'orange' : 'default'">
            {{ filteredReviewApps.length }} {{ 'official.third-party-app.review.queue-count' | i18n }}
          </nz-tag>
        </div>

        <div class="review-skeleton-list" *ngIf="loading" [testId]="'official-third-party-review-loading'">
          <div class="review-skeleton-card" *ngFor="let item of [1, 2]">
            <div class="review-skeleton-avatar"></div>
            <div class="review-skeleton-copy">
              <span></span>
              <span></span>
              <span></span>
            </div>
            <div class="review-skeleton-action"></div>
          </div>
        </div>

        <nz-card
          class="review-card"
          *ngFor="let item of filteredReviewApps"
          [testId]="'official-third-party-review-card-' + item.id"
          [class.review-card-loading-hidden]="loading"
        >
          <div class="review-card-top">
            <div class="review-app-avatar">
              <img *ngIf="item.iconUrl" [src]="item.iconUrl" [alt]="item.appName" />
              <i *ngIf="!item.iconUrl" nz-icon nzType="appstore" nzTheme="outline"></i>
            </div>
            <div class="review-main">
              <div class="review-title-row">
                <h3>{{ item.appName }}</h3>
                <nz-tag class="app-meta-tag app-meta-tag-id">{{ item.appId }}</nz-tag>
                <nz-tag class="review-channel-tag">{{ getReviewChannelLabelI18nKey(item.channel) | i18n }}</nz-tag>
                <nz-tag [nzColor]="item.status === 'InReview' ? 'orange' : item.status === 'Draft' ? 'blue' : 'red'">
                  {{ 'official.third-party-app.review.status.' + item.status | i18n }}
                </nz-tag>
              </div>
              <p class="review-provider">{{ item.provider }} · {{ item.version }}</p>
              <p class="review-description">{{ item.description }}</p>
              <p class="review-submitted">{{ 'official.third-party-app.review.submitted-at' | i18n }} {{ item.submittedAt }}</p>
            </div>
            <div class="app-actions">
              <button
                nz-button
                nzType="primary"
                type="button"
                class="review-action-button"
                (click)="openReview(item)"
                [disabled]="item.status !== 'InReview'"
                [testId]="'official-third-party-review-button-' + item.id"
              >
                <i nz-icon nzType="audit" nzTheme="outline"></i>
                {{ 'official.third-party-app.review.action' | i18n }}
              </button>
            </div>
          </div>
          <div class="review-detail" *ngIf="item.expanded">
            <div
              ><span>{{ 'official.third-party-app.form.provider' | i18n }}</span
              ><strong>{{ item.provider }}</strong></div
            >
            <div
              ><span>{{ 'official.third-party-app.form.version' | i18n }}</span
              ><strong>{{ item.version }}</strong></div
            >
            <div
              ><span>{{ 'official.third-party-app.review.channel' | i18n }}</span
              ><strong>{{ item.channel }}</strong></div
            >
            <div class="review-detail-description"
              ><span>{{ 'official.third-party-app.form.description' | i18n }}</span
              ><strong>{{ item.description }}</strong></div
            >
            <div class="review-reason" *ngIf="item.reviewReason"
              ><span>{{ 'official.third-party-app.review.reason' | i18n }}</span
              ><strong>{{ item.reviewReason }}</strong></div
            >
          </div>
        </nz-card>
        <nz-card class="review-empty" *ngIf="!loading && !filteredReviewApps.length">
          <i nz-icon nzType="inbox" nzTheme="outline"></i>
          <strong>{{ 'official.third-party-app.review.empty' | i18n }}</strong>
          <span>{{ 'official.third-party-app.review.empty-hint' | i18n }}</span>
          <button nz-button nzType="default" type="button" (click)="refreshApps()" [testId]="'official-third-party-review-refresh-button'">
            <i nz-icon nzType="reload" nzTheme="outline"></i>
            {{ 'common.refresh' | i18n }}
          </button>
        </nz-card>
      </div>

      <div class="app-list" [testId]="'official-third-party-list'">
        <ng-container *ngIf="currentTab === 'connected' || currentTab === 'drafts'">
          <div class="app-list-toolbar">
            <div>
              <h3>{{
                (currentTab === 'connected' ? 'official.third-party-app.tab.connected' : 'official.third-party-app.tab.drafts') | i18n
              }}</h3>
              <p>
                {{
                  (currentTab === 'connected' ? 'official.third-party-app.published.hint' : 'official.third-party-app.draft.hint') | i18n
                }}
              </p>
            </div>
            <nz-tag class="app-count-tag" [nzColor]="apps.length ? 'blue' : 'default'">
              {{ apps.length }} {{ 'official.third-party-app.list-count' | i18n }}
            </nz-tag>
          </div>

          <div class="review-skeleton-list" *ngIf="loading" [testId]="'official-third-party-app-loading'">
            <div class="review-skeleton-card" *ngFor="let item of [1, 2]">
              <div class="review-skeleton-avatar"></div>
              <div class="review-skeleton-copy"><span></span><span></span><span></span></div>
              <div class="review-skeleton-action"></div>
            </div>
          </div>

          <nz-card
            class="app-card"
            *ngFor="let app of apps; trackBy: trackByApp"
            [class.app-card-loading-hidden]="loading"
            [testId]="'official-third-party-card-' + app.id"
          >
            <div class="app-card-top">
              <div class="app-app-avatar">
                <img *ngIf="app.iconUrl" [src]="app.iconUrl" [alt]="app.appName" />
                <i *ngIf="!app.iconUrl" nz-icon nzType="appstore" nzTheme="outline"></i>
              </div>
              <div class="app-copy">
                <div class="app-title-row">
                  <h3>{{ app.appName }}</h3>
                  <nz-tag class="app-meta-tag app-meta-tag-id">{{ app.appId }}</nz-tag>
                  <nz-tag
                    class="app-meta-tag app-status-tag"
                    [ngClass]="{
                      'app-status-tag-active': app.status === 'Active',
                      'app-status-tag-draft': app.status === 'Draft',
                      'app-status-tag-rejected': app.status === 'Rejected',
                      'app-status-tag-disabled': app.status === 'Disabled',
                      'app-status-tag-deleted': app.status === 'Deleted'
                    }"
                  >
                    {{ 'official.third-party-app.status.' + app.status | i18n }}
                  </nz-tag>
                  <nz-tag class="app-meta-tag">{{ getAuthTypeLabelI18nKey(app.controlPlaneAuthType) | i18n }}</nz-tag>
                  <nz-tag class="app-meta-tag">{{ getInstallAckModeLabelI18nKey(app.installAckMode) | i18n }}</nz-tag>
                </div>
                <p class="app-description">{{ app.provider }}</p>
                <p class="app-url">{{ app.controlPlaneDisplayUrl }}</p>
              </div>

              <div class="app-actions">
                <button
                  nz-button
                  nzType="default"
                  type="button"
                  class="app-action-button app-action-button-detail"
                  (click)="toggleExpanded(app.id)"
                  [testId]="'official-third-party-toggle-detail-' + app.id"
                >
                  <i nz-icon [nzType]="app.expanded ? 'up' : 'down'" nzTheme="outline"></i>
                  {{ (app.expanded ? 'official.third-party-app.collapse' : 'official.third-party-app.expand') | i18n }}
                </button>
                <button
                  nz-button
                  nzType="default"
                  type="button"
                  class="app-action-button app-action-button-enable"
                  (click)="enableApp(app)"
                  *ngIf="app.status === 'Disabled'"
                  [disabled]="operatingAppId === app.id"
                  [testId]="'official-third-party-enable-' + app.id"
                >
                  <i nz-icon nzType="check-circle" nzTheme="outline"></i>
                  {{ 'official.third-party-app.enable' | i18n }}
                </button>
                <button
                  nz-button
                  nzType="default"
                  type="button"
                  class="app-action-button app-action-button-disable"
                  (click)="disableApp(app)"
                  *ngIf="app.status === 'Active'"
                  [disabled]="operatingAppId === app.id"
                  [testId]="'official-third-party-disable-' + app.id"
                >
                  <i nz-icon nzType="pause-circle" nzTheme="outline"></i>
                  {{ 'official.third-party-app.disable' | i18n }}
                </button>
                <button
                  nz-button
                  nzType="default"
                  type="button"
                  class="app-action-button app-action-button-edit"
                  (click)="openEditModal(app)"
                  *ngIf="currentTab === 'drafts'"
                  [testId]="'official-third-party-edit-' + app.id"
                >
                  <i nz-icon nzType="edit" nzTheme="outline"></i>
                  {{ 'official.third-party-app.edit' | i18n }}
                </button>
                <button
                  nz-button
                  nzType="primary"
                  type="button"
                  class="app-action-button app-action-button-submit"
                  (click)="submitDraft(app)"
                  *ngIf="currentTab === 'drafts'"
                  [disabled]="operatingAppId === app.id"
                  [nzLoading]="operatingAppId === app.id"
                  [testId]="'official-third-party-submit-' + app.id"
                >
                  <i nz-icon nzType="send" nzTheme="outline"></i>
                  {{ 'official.third-party-app.draft.submit' | i18n }}
                </button>
                <button
                  nz-button
                  nzType="default"
                  type="button"
                  class="app-action-button app-action-button-danger"
                  (click)="deleteApp(app)"
                  *ngIf="currentTab === 'connected' || currentTab === 'drafts'"
                  [disabled]="operatingAppId === app.id"
                  [nzLoading]="operatingAppId === app.id"
                  [testId]="'official-third-party-delete-' + app.id"
                >
                  <i nz-icon nzType="delete" nzTheme="outline" *ngIf="operatingAppId !== app.id"></i>
                  {{ (currentTab === 'drafts' ? 'official.third-party-app.draft.delete' : 'official.third-party-app.delete') | i18n }}
                </button>
              </div>
            </div>

            <div nz-row [nzGutter]="12" class="metric-grid">
              <div nz-col [nzXs]="24" [nzMd]="8">
                <div class="metric-card">
                  <div class="metric-label">{{ 'official.third-party-app.metrics.endpoints' | i18n }}</div>
                  <div class="metric-value">{{ getObjectSize(app.controlPlaneEndpoints) }}</div>
                </div>
              </div>
              <div nz-col [nzXs]="24" [nzMd]="8">
                <div class="metric-card">
                  <div class="metric-label">{{ 'official.third-party-app.metrics.supported-events' | i18n }}</div>
                  <div class="metric-value">{{ app.supportedEvents.length }}</div>
                </div>
              </div>
              <div nz-col [nzXs]="24" [nzMd]="8">
                <div class="metric-card">
                  <div class="metric-label">{{ 'official.third-party-app.metrics.headers' | i18n }}</div>
                  <div class="metric-value">{{ getObjectSize(app.controlPlaneHeaders) }}</div>
                </div>
              </div>
            </div>

            <div nz-row [nzGutter]="12" class="detail-grid" *ngIf="app.expanded">
              <div nz-col [nzXs]="24" [nzLg]="8">
                <div class="detail-panel">
                  <h4>{{ 'official.third-party-app.detail.endpoints' | i18n }}</h4>
                  <div class="mapping-item" *ngFor="let endpoint of app.controlPlaneEndpoints | keyvalue">
                    <div class="mapping-internal">{{ endpoint.key }}</div>
                    <div class="mapping-external">{{ endpoint.value }}</div>
                  </div>
                </div>
              </div>

              <div nz-col [nzXs]="24" [nzLg]="8">
                <div class="detail-panel">
                  <h4>{{ 'official.third-party-app.detail.events' | i18n }}</h4>
                  <div class="event-item" *ngFor="let event of app.supportedEvents">{{ event }}</div>
                </div>
              </div>

              <div nz-col [nzXs]="24" [nzLg]="8">
                <div class="detail-panel">
                  <h4>{{ 'official.third-party-app.detail.auth' | i18n }}</h4>
                  <p class="signature-text">
                    {{ 'official.third-party-app.detail.auth-type' | i18n }}: {{ getAuthTypeLabelI18nKey(app.controlPlaneAuthType) | i18n }}
                  </p>
                  <p class="signature-text">
                    {{ 'official.third-party-app.detail.install-ack-mode' | i18n }}:
                    {{ getInstallAckModeLabelI18nKey(app.installAckMode) | i18n }}
                  </p>
                  <div class="secret-row" *ngIf="app.controlPlaneSecret">
                    <span class="signature-text secret-label">{{ 'official.third-party-app.detail.secret' | i18n }}:</span>
                    <span class="signature-text secret-value" [testId]="'official-third-party-secret-value-' + app.id">
                      {{ getDisplaySecret(app) }}
                    </span>
                    <button
                      nz-button
                      nzType="text"
                      type="button"
                      class="secret-icon-button"
                      (click)="toggleSecretVisibility(app.id)"
                      [testId]="'official-third-party-secret-toggle-' + app.id"
                    >
                      <i nz-icon [nzType]="isSecretVisible(app.id) ? 'eye-invisible' : 'eye'" nzTheme="outline"></i>
                    </button>
                    <button
                      nz-button
                      nzType="text"
                      type="button"
                      class="secret-icon-button"
                      (click)="copySecret(app)"
                      [testId]="'official-third-party-secret-copy-' + app.id"
                    >
                      <i nz-icon nzType="copy" nzTheme="outline"></i>
                    </button>
                  </div>
                  <div class="scope-tags">
                    <nz-tag *ngFor="let header of app.controlPlaneHeaders | keyvalue">{{ header.key }}: {{ header.value }}</nz-tag>
                  </div>
                </div>
              </div>
            </div>
          </nz-card>
          <nz-card class="review-empty app-empty" *ngIf="!loading && !apps.length">
            <i nz-icon [nzType]="currentTab === 'drafts' ? 'file-text' : 'appstore'" nzTheme="outline"></i>
            <strong>{{
              (currentTab === 'drafts' ? 'official.third-party-app.draft.empty' : 'official.third-party-app.published.empty') | i18n
            }}</strong>
            <span>{{
              (currentTab === 'drafts' ? 'official.third-party-app.draft.hint' : 'official.third-party-app.published.hint') | i18n
            }}</span>
            <button
              nz-button
              nzType="default"
              type="button"
              (click)="currentTab === 'drafts' ? openCreateModal() : refreshApps()"
              [testId]="'official-third-party-empty-action-button'"
            >
              <i nz-icon [nzType]="currentTab === 'drafts' ? 'plus' : 'reload'" nzTheme="outline"></i>
              {{ (currentTab === 'drafts' ? 'official.third-party-app.create' : 'common.refresh') | i18n }}
            </button>
          </nz-card>
        </ng-container>
      </div>
    </div>
  </div>
</div>

<nz-modal
  [nzVisible]="!!selectedReview"
  [nzTitle]="'official.third-party-app.review.modal-title' | i18n"
  [nzFooter]="null"
  nzWrapClassName="review-app-modal-wrap"
  (nzOnCancel)="closeReview()"
  [nzWidth]="1040"
  [testId]="'official-third-party-review-modal'"
>
  <ng-container *nzModalContent>
    <div class="review-modal" *ngIf="selectedReview">
      <div class="review-modal-header">
        <div>
          <h3>{{ selectedReview.appName }}</h3>
          <p>
            {{ selectedReview.provider }} · {{ selectedReview.version }} ·
            {{ getReviewChannelLabelI18nKey(selectedReview.channel) | i18n }}
          </p>
        </div>
        <nz-tag [nzColor]="selectedReview.status === 'InReview' ? 'orange' : selectedReview.status === 'Draft' ? 'blue' : 'red'">
          {{ 'official.third-party-app.review.status.' + selectedReview.status | i18n }}
        </nz-tag>
      </div>

      <div class="review-modal-columns">
        <section class="review-modal-details" [testId]="'official-third-party-review-details'">
          <div class="review-modal-detail-grid">
            <div class="review-modal-section review-modal-section-full" *ngIf="selectedReview.iconUrl"
              ><img class="review-modal-icon" [src]="selectedReview.iconUrl" alt=""
            /></div>
            <div class="review-modal-section"
              ><h4>{{ 'official.third-party-app.form.app-id' | i18n }}</h4
              ><p>{{ selectedReview.appId }}</p></div
            >
            <div class="review-modal-section"
              ><h4>{{ 'official.third-party-app.form.provider' | i18n }}</h4
              ><p>{{ selectedReview.provider }}</p></div
            >
            <div class="review-modal-section"
              ><h4>{{ 'official.third-party-app.form.category' | i18n }}</h4
              ><p>{{ getCategoryLabel(selectedReview.category) }}</p></div
            >
            <div class="review-modal-section"
              ><h4>{{ 'official.third-party-app.form.version' | i18n }}</h4
              ><p>{{ selectedReview.version }}</p></div
            >
            <div class="review-modal-section review-modal-section-full"
              ><h4>{{ 'official.third-party-app.form.short-description' | i18n }}</h4
              ><p>{{ selectedReview.shortDescription || '-' }}</p></div
            >
            <div class="review-modal-section review-modal-section-full"
              ><h4>{{ 'official.third-party-app.form.description' | i18n }}</h4
              ><p>{{ selectedReview.description }}</p></div
            >
            <div class="review-modal-section review-modal-section-full"
              ><h4>{{ 'official.third-party-app.form.control-plane-base-url' | i18n }}</h4
              ><p class="review-modal-code">{{ selectedReview.controlPlaneBaseUrl }}</p></div
            >
            <div class="review-modal-section"
              ><h4>{{ 'official.third-party-app.detail.auth-type' | i18n }}</h4
              ><p>{{ getAuthTypeLabelI18nKey(selectedReview.controlPlaneAuthType) | i18n }}</p></div
            >
            <div class="review-modal-section"
              ><h4>{{ 'official.third-party-app.detail.install-ack-mode' | i18n }}</h4
              ><p>{{ getInstallAckModeLabelI18nKey(selectedReview.installAckMode) | i18n }}</p></div
            >
            <div class="review-modal-section"
              ><h4>{{ 'official.third-party-app.detail.endpoints' | i18n }}</h4
              ><div class="review-modal-list" *ngFor="let endpoint of selectedReview.controlPlaneEndpoints | keyvalue"
                ><strong>{{ endpoint.key }}</strong
                ><span>{{ endpoint.value }}</span></div
              ></div
            >
            <div class="review-modal-section"
              ><h4>{{ 'official.third-party-app.detail.events' | i18n }}</h4
              ><div class="review-modal-tags"
                ><nz-tag *ngFor="let event of selectedReview.supportedEvents"
                  >{{ getSupportedEventLabel(event) }} · {{ event }}</nz-tag
                ></div
              ></div
            >
            <div class="review-modal-section review-modal-section-full" *ngIf="selectedReview.controlPlaneHeaders | keyvalue as headers"
              ><h4>{{ 'official.third-party-app.form.control-plane-headers' | i18n }}</h4
              ><div class="review-modal-tags"
                ><nz-tag *ngFor="let header of headers">{{ header.key }}: {{ header.value }}</nz-tag></div
              ></div
            >
          </div>
        </section>

        <aside class="review-modal-decision" [testId]="'official-third-party-review-decision'">
          <div class="review-decision-heading">
            <span class="review-decision-eyebrow">{{ 'official.third-party-app.review.action' | i18n }}</span>
            <h4>{{ 'official.third-party-app.review.decision-title' | i18n }}</h4>
            <p>{{ 'official.third-party-app.review.decision-hint' | i18n }}</p>
          </div>
          <nz-radio-group [(ngModel)]="reviewDecision" class="review-decision-group">
            <label nz-radio nzValue="approve">{{ 'official.third-party-app.review.approve' | i18n }}</label>
            <label nz-radio nzValue="changes">{{ 'official.third-party-app.review.request-changes' | i18n }}</label>
          </nz-radio-group>
          <ng-container *ngIf="reviewDecision === 'changes'">
            <label class="review-field-label" for="review-reason-code">{{ 'official.third-party-app.review.reason' | i18n }}</label>
            <select id="review-reason-code" [(ngModel)]="reviewReasonCode" class="review-reason-select">
              <option value="DeveloperInfoMissing">{{ 'official.third-party-app.review.reason-code.DeveloperInfoMissing' | i18n }}</option>
              <option value="PrivacyPolicyMissing">{{ 'official.third-party-app.review.reason-code.PrivacyPolicyMissing' | i18n }}</option>
              <option value="InstallEndpointInvalid">{{
                'official.third-party-app.review.reason-code.InstallEndpointInvalid' | i18n
              }}</option>
              <option value="PermissionScopeIncomplete">{{
                'official.third-party-app.review.reason-code.PermissionScopeIncomplete' | i18n
              }}</option>
              <option value="StoreContentInvalid">{{ 'official.third-party-app.review.reason-code.StoreContentInvalid' | i18n }}</option>
              <option value="Other">{{ 'official.third-party-app.review.reason-code.Other' | i18n }}</option>
            </select>
            <label class="review-field-label" for="review-reason-description">{{
              'official.third-party-app.review.reason-placeholder' | i18n
            }}</label>
            <textarea
              id="review-reason-description"
              nz-input
              [(ngModel)]="reviewReason"
              [placeholder]="'official.third-party-app.review.reason-placeholder' | i18n"
              [nzAutosize]="{ minRows: 3, maxRows: 6 }"
              [testId]="'official-third-party-review-reason-textarea'"
            ></textarea>
          </ng-container>
          <div class="review-modal-actions">
            <button nz-button type="button" (click)="closeReview()" [testId]="'official-third-party-review-cancel-button'">{{
              'common.cancel' | i18n
            }}</button>
            <button
              nz-button
              nzType="primary"
              type="button"
              (click)="submitReview()"
              [testId]="'official-third-party-review-submit-button'"
            >
              <i nz-icon nzType="check-circle" nzTheme="outline"></i>
              {{ 'official.third-party-app.review.confirm' | i18n }}
            </button>
          </div>
        </aside>
      </div>
    </div>
  </ng-container>
</nz-modal>

<nz-modal
  [nzVisible]="modalVisible"
  [nzTitle]="(modalMode === 'create' ? 'official.third-party-app.modal.create-title' : 'official.third-party-app.modal.edit-title') | i18n"
  [nzOkText]="(modalMode === 'create' ? 'official.third-party-app.draft.save' : 'common.save') | i18n"
  [nzCancelText]="'common.cancel' | i18n"
  [nzOkLoading]="saving"
  [nzWidth]="760"
  nzWrapClassName="integration-app-modal-wrap"
  (nzOnCancel)="closeModal()"
  (nzOnOk)="saveApp()"
  [testId]="'official-third-party-modal'"
>
  <ng-container *nzModalContent>
    <div class="modal-scroll-body">
      <p class="modal-helper">{{ 'official.third-party-app.modal.helper' | i18n }}</p>

      <form nz-form nzLayout="vertical" [formGroup]="appForm" class="modal-form" testId="official-third-party-form">
        <div class="modal-section-heading">
          <h3>{{ 'official.third-party-app.form.store-info' | i18n }}</h3>
          <p>{{ 'official.third-party-app.form.store-info-hint' | i18n }}</p>
        </div>
        <nz-form-item>
          <nz-form-label nzRequired>{{ 'official.third-party-app.form.app-id' | i18n }}</nz-form-label>
          <nz-form-control [nzErrorTip]="'official.third-party-app.form.app-id-required' | i18n">
            <input
              nz-input
              formControlName="appId"
              [readonly]="modalMode === 'edit'"
              [placeholder]="'official.third-party-app.form.app-id-placeholder' | i18n"
              testId="official-third-party-app-id-input"
            />
          </nz-form-control>
        </nz-form-item>

        <nz-form-item>
          <nz-form-label nzRequired>{{ 'official.third-party-app.form.app-name' | i18n }}</nz-form-label>
          <nz-form-control [nzErrorTip]="'official.third-party-app.form.app-name-required' | i18n">
            <input
              nz-input
              formControlName="appName"
              [placeholder]="'official.third-party-app.form.app-name-placeholder' | i18n"
              testId="official-third-party-app-name-input"
            />
          </nz-form-control>
        </nz-form-item>

        <nz-form-item>
          <nz-form-label nzRequired>{{ 'official.third-party-app.form.provider' | i18n }}</nz-form-label>
          <nz-form-control [nzErrorTip]="'official.third-party-app.form.provider-required' | i18n">
            <input
              nz-input
              formControlName="provider"
              [placeholder]="'official.third-party-app.form.provider-placeholder' | i18n"
              testId="official-third-party-provider-input"
            />
          </nz-form-control>
        </nz-form-item>

        <div class="app-publishing-meta-grid">
          <nz-form-item
            ><nz-form-label nzRequired>{{ 'official.third-party-app.form.category' | i18n }}</nz-form-label
            ><nz-form-control [nzErrorTip]="'official.third-party-app.form.category-required' | i18n"
              ><select class="app-category-select" formControlName="category"
                ><option value="">{{ 'official.third-party-app.form.category-placeholder' | i18n }}</option
                ><option value="CRM">{{ 'official.third-party-app.category.CRM' | i18n }}</option
                ><option value="Productivity">{{ 'official.third-party-app.category.Productivity' | i18n }}</option></select
              ></nz-form-control
            ></nz-form-item
          >
          <nz-form-item
            ><nz-form-label nzRequired>{{ 'official.third-party-app.form.version' | i18n }}</nz-form-label
            ><nz-form-control [nzErrorTip]="'official.third-party-app.form.version-required' | i18n"
              ><input
                nz-input
                formControlName="version"
                [placeholder]="'official.third-party-app.form.version-placeholder' | i18n"
                testId="official-third-party-form-version-input" /></nz-form-control
          ></nz-form-item>
        </div>
        <nz-form-item
          ><nz-form-label nzRequired>{{ 'official.third-party-app.form.short-description' | i18n }}</nz-form-label
          ><nz-form-control [nzErrorTip]="'official.third-party-app.form.short-description-required' | i18n"
            ><input
              nz-input
              formControlName="shortDescription"
              [placeholder]="'official.third-party-app.form.short-description-placeholder' | i18n"
              testId="official-third-party-form-short-description-input" /></nz-form-control
        ></nz-form-item>
        <nz-form-item
          ><nz-form-label nzRequired>{{ 'official.third-party-app.form.description' | i18n }}</nz-form-label
          ><nz-form-control [nzErrorTip]="'official.third-party-app.form.description-required' | i18n">
            <textarea
              nz-input
              formControlName="description"
              [nzAutosize]="{ minRows: 3, maxRows: 6 }"
              [placeholder]="'official.third-party-app.form.description-placeholder' | i18n"
              testId="official-third-party-form-description-textarea"
            ></textarea></nz-form-control
        ></nz-form-item>
        <nz-form-item
          ><nz-form-label nzRequired>{{ 'official.third-party-app.form.icon' | i18n }}</nz-form-label
          ><nz-form-control
            [nzValidateStatus]="appForm.controls.iconFileId"
            [nzErrorTip]="'official.third-party-app.form.icon-required' | i18n"
            ><div class="app-icon-picker"
              ><img
                *ngIf="appForm.controls.iconUrl.value"
                [src]="appForm.controls.iconUrl.value"
                class="app-icon-preview"
                [alt]="'official.third-party-app.form.icon-preview' | i18n"
              /><div class="app-icon-picker-copy"
                ><label class="app-icon-upload"
                  ><i nz-icon nzType="upload" nzTheme="outline"></i
                  ><span>{{
                    (appForm.controls.iconUrl.value
                      ? 'official.third-party-app.form.icon-replace'
                      : 'official.third-party-app.form.icon-select'
                    ) | i18n
                  }}</span
                  ><input
                    type="file"
                    accept="image/png,image/jpeg,image/webp"
                    (change)="onIconSelected($event)"
                    testId="official-third-party-form-icon-file-input" /></label
                ><span>{{ 'official.third-party-app.form.icon-hint' | i18n }}</span></div
              ></div
            ></nz-form-control
          ></nz-form-item
        >

        <div class="modal-section-heading modal-section-heading-integration">
          <h3>{{ 'official.third-party-app.form.integration' | i18n }}</h3>
          <p>{{ 'official.third-party-app.form.integration-hint' | i18n }}</p>
        </div>

        <nz-form-item>
          <nz-form-label nzRequired>{{ 'official.third-party-app.form.control-plane-base-url' | i18n }}</nz-form-label>
          <nz-form-control [nzErrorTip]="'official.third-party-app.form.control-plane-base-url-required' | i18n">
            <input
              nz-input
              formControlName="controlPlaneBaseUrl"
              [placeholder]="'official.third-party-app.form.control-plane-base-url-placeholder' | i18n"
              testId="official-third-party-control-plane-base-url-input"
            />
          </nz-form-control>
        </nz-form-item>

        <nz-form-item>
          <nz-form-label nzRequired>{{ 'official.third-party-app.form.control-plane-auth-type' | i18n }}</nz-form-label>
          <nz-form-control>
            <nz-radio-group formControlName="controlPlaneAuthType" testId="official-third-party-auth-type-group">
              <label
                nz-radio
                *ngFor="let authType of authTypeOptions"
                [nzValue]="authType"
                class="auth-option"
                [testId]="'official-third-party-auth-type-option-' + authType"
              >
                <span class="auth-option-label">{{ getAuthTypeLabelI18nKey(authType) | i18n }}</span>
              </label>
            </nz-radio-group>
          </nz-form-control>
        </nz-form-item>

        <nz-form-item>
          <nz-form-label nzRequired>{{ 'official.third-party-app.form.install-ack-mode' | i18n }}</nz-form-label>
          <nz-form-control>
            <nz-radio-group formControlName="installAckMode" testId="official-third-party-install-ack-mode-group">
              <label nz-radio [nzValue]="'Sync'" class="auth-option" testId="official-third-party-install-ack-mode-sync">
                <span class="auth-option-label">{{ getInstallAckModeLabelI18nKey('Sync') | i18n }}</span>
              </label>
              <label nz-radio [nzValue]="'Async'" class="auth-option" testId="official-third-party-install-ack-mode-async">
                <span class="auth-option-label">{{ getInstallAckModeLabelI18nKey('Async') | i18n }}</span>
              </label>
            </nz-radio-group>
          </nz-form-control>
        </nz-form-item>

        <nz-form-item *ngIf="shouldShowSecretField">
          <nz-form-label nzRequired>{{ 'official.third-party-app.form.control-plane-secret' | i18n }}</nz-form-label>
          <nz-form-control [nzErrorTip]="'official.third-party-app.form.control-plane-secret-required' | i18n">
            <input
              nz-input
              formControlName="controlPlaneSecret"
              [placeholder]="'official.third-party-app.form.control-plane-secret-placeholder' | i18n"
              testId="official-third-party-control-plane-secret-input"
            />
          </nz-form-control>
        </nz-form-item>

        <nz-form-item *ngIf="shouldShowHeadersField">
          <nz-form-label nzRequired>{{ 'official.third-party-app.form.control-plane-headers' | i18n }}</nz-form-label>
          <nz-form-control [nzErrorTip]="'official.third-party-app.form.control-plane-headers-required' | i18n">
            <textarea
              nz-input
              formControlName="controlPlaneHeadersText"
              [placeholder]="'official.third-party-app.form.control-plane-headers-placeholder' | i18n"
              [nzAutosize]="{ minRows: 3, maxRows: 5 }"
              testId="official-third-party-control-plane-headers-input"
            ></textarea>
          </nz-form-control>
        </nz-form-item>

        <nz-form-item>
          <nz-form-label nzRequired>{{ 'official.third-party-app.form.control-plane-endpoints' | i18n }}</nz-form-label>
          <nz-form-control
            [nzValidateStatus]="appForm.controls.controlPlaneInstallEndpoint"
            [nzErrorTip]="controlPlaneEndpointsErrorI18nKey | i18n"
          >
            <div class="endpoint-config-panel" testId="official-third-party-endpoint-config-panel">
              <div class="endpoint-option-grid" testId="official-third-party-endpoint-option-grid">
                <label
                  nz-checkbox
                  [nzChecked]="true"
                  [nzDisabled]="true"
                  class="endpoint-option endpoint-option-required endpoint-option-locked"
                  testId="official-third-party-endpoint-option-install"
                >
                  <span class="endpoint-option-text">
                    {{ getEndpointLabelI18nKey('install') | i18n }}
                    <span class="endpoint-required-mark">*</span>
                  </span>
                </label>
                <label
                  nz-checkbox
                  *ngFor="let endpointKey of optionalEndpointOptions"
                  [nzChecked]="isOptionalEndpointSelected(endpointKey)"
                  (nzCheckedChange)="toggleOptionalEndpoint(endpointKey, $event)"
                  class="endpoint-option"
                  [testId]="'official-third-party-endpoint-option-' + endpointKey"
                >
                  <span class="endpoint-option-text">
                    {{ getEndpointLabelI18nKey(endpointKey) | i18n }}
                    <span class="endpoint-required-mark" *ngIf="isOptionalEndpointRequired(endpointKey)">*</span>
                  </span>
                </label>
              </div>

              <div class="endpoint-config-list" testId="official-third-party-endpoint-config-list">
                <div class="endpoint-config-row endpoint-config-row-required" testId="official-third-party-endpoint-row-install">
                  <div class="endpoint-config-label">
                    <span>{{ getEndpointLabelI18nKey('install') | i18n }}</span>
                    <span class="endpoint-required-mark">*</span>
                  </div>
                  <input
                    nz-input
                    formControlName="controlPlaneInstallEndpoint"
                    [placeholder]="'official.third-party-app.form.endpoint-path-placeholder' | i18n"
                    testId="official-third-party-install-endpoint-input"
                  />
                </div>

                <div
                  class="endpoint-config-row"
                  *ngIf="isOptionalEndpointSelected('update')"
                  testId="official-third-party-endpoint-row-update"
                >
                  <div class="endpoint-config-label">
                    <span>{{ getEndpointLabelI18nKey('update') | i18n }}</span>
                    <span class="endpoint-required-mark">*</span>
                  </div>
                  <input
                    nz-input
                    formControlName="controlPlaneUpdateEndpoint"
                    [placeholder]="'official.third-party-app.form.endpoint-path-placeholder' | i18n"
                    testId="official-third-party-update-endpoint-input"
                  />
                </div>

                <div
                  class="endpoint-config-row"
                  *ngIf="isOptionalEndpointSelected('rotateSecret')"
                  testId="official-third-party-endpoint-row-rotate-secret"
                >
                  <div class="endpoint-config-label">
                    <span>{{ getEndpointLabelI18nKey('rotateSecret') | i18n }}</span>
                    <span class="endpoint-required-mark">*</span>
                  </div>
                  <input
                    nz-input
                    formControlName="controlPlaneRotateSecretEndpoint"
                    [placeholder]="'official.third-party-app.form.endpoint-path-placeholder' | i18n"
                    testId="official-third-party-rotate-secret-endpoint-input"
                  />
                </div>

                <div
                  class="endpoint-config-row"
                  *ngIf="isOptionalEndpointSelected('uninstall')"
                  testId="official-third-party-endpoint-row-uninstall"
                >
                  <div class="endpoint-config-label">
                    <span>{{ getEndpointLabelI18nKey('uninstall') | i18n }}</span>
                    <span class="endpoint-required-mark">*</span>
                  </div>
                  <input
                    nz-input
                    formControlName="controlPlaneUninstallEndpoint"
                    [placeholder]="'official.third-party-app.form.endpoint-path-placeholder' | i18n"
                    testId="official-third-party-uninstall-endpoint-input"
                  />
                </div>
              </div>
            </div>
          </nz-form-control>
        </nz-form-item>

        <nz-form-item>
          <nz-form-label nzRequired>{{ 'official.third-party-app.form.supported-events' | i18n }}</nz-form-label>
          <nz-form-control [nzValidateStatus]="appForm.controls.supportedEventsText" [nzErrorTip]="supportedEventsErrorI18nKey | i18n">
            <div class="supported-events-panel" testId="official-third-party-supported-events-panel">
              <div class="supported-events-section" testId="official-third-party-supported-events-recommended-section">
                <div class="supported-events-section-title">{{ 'official.third-party-app.form.supported-events-recommended' | i18n }}</div>
                <div class="supported-events-recommended-grid" testId="official-third-party-supported-events-recommended-grid">
                  <label
                    nz-checkbox
                    *ngFor="let pattern of recommendedSupportedEvents"
                    [nzChecked]="isRecommendedSupportedEventSelected(pattern)"
                    (nzCheckedChange)="toggleRecommendedSupportedEvent(pattern, $event)"
                    class="supported-event-option"
                    [testId]="'official-third-party-supported-event-recommended-' + pattern"
                  >
                    <span class="supported-event-option-copy">
                      <span class="supported-event-option-title">{{ getSupportedEventLabel(pattern) }}</span>
                      <span class="supported-event-option-text">{{ pattern }}</span>
                    </span>
                  </label>
                </div>
              </div>

              <div class="supported-events-section" testId="official-third-party-supported-events-custom-section">
                <div class="supported-events-section-title">{{ 'official.third-party-app.form.supported-events-custom' | i18n }}</div>
                <div class="supported-events-custom-row" testId="official-third-party-supported-events-custom-row">
                  <input
                    nz-input
                    type="text"
                    [value]="customSupportedEventDraft"
                    (input)="customSupportedEventDraft = $any($event.target).value"
                    (keydown.enter)="$event.preventDefault(); addCustomSupportedEvent()"
                    [placeholder]="'official.third-party-app.form.supported-events-custom-placeholder' | i18n"
                    testId="official-third-party-supported-events-custom-input"
                  />
                  <button
                    nz-button
                    nzType="default"
                    type="button"
                    (click)="addCustomSupportedEvent()"
                    testId="official-third-party-supported-events-add-button"
                  >
                    {{ 'official.third-party-app.form.supported-events-add' | i18n }}
                  </button>
                </div>
              </div>

              <div class="supported-events-section" testId="official-third-party-supported-events-selected-section">
                <div class="supported-events-section-title">{{ 'official.third-party-app.form.supported-events-selected' | i18n }}</div>
                <div
                  class="supported-events-selected-empty"
                  *ngIf="!selectedSupportedEvents.length"
                  testId="official-third-party-supported-events-empty"
                >
                  {{ 'official.third-party-app.form.supported-events-empty' | i18n }}
                </div>
                <div
                  class="supported-events-tags"
                  *ngIf="selectedSupportedEvents.length"
                  testId="official-third-party-supported-events-tags"
                >
                  <nz-tag
                    *ngFor="let event of selectedSupportedEvents"
                    nzMode="closeable"
                    (nzOnClose)="removeSupportedEvent(event)"
                    [testId]="'official-third-party-supported-event-selected-' + event"
                  >
                    {{ event }}
                  </nz-tag>
                </div>
              </div>
            </div>
          </nz-form-control>
        </nz-form-item>
      </form>
    </div>
  </ng-container>
</nz-modal>

<nz-modal
  [nzVisible]="deleteConfirmVisible"
  [nzTitle]="'official.third-party-app.delete-confirm.second-title' | i18n"
  [nzOkText]="'official.third-party-app.delete' | i18n"
  [nzCancelText]="'common.cancel' | i18n"
  [nzOkDanger]="true"
  [nzOkDisabled]="!deleteConfirmIdentifierMatches || operatingAppId === pendingDeleteApp?.id"
  [nzOkLoading]="operatingAppId === pendingDeleteApp?.id"
  (nzOnCancel)="closeDeleteConfirm()"
  (nzOnOk)="confirmDeleteApp()"
  [testId]="'official-third-party-delete-confirm-modal'"
>
  <ng-container *nzModalContent>
    <div class="delete-confirm-content">
      <div class="delete-confirm-warning">
        <p class="delete-confirm-copy">
          {{
            'official.third-party-app.delete-confirm.second-content'
              | i18n: { name: pendingDeleteApp?.appName ?? '', appId: deleteConfirmIdentifier }
          }}
        </p>
        <p class="delete-confirm-helper">
          {{ 'official.third-party-app.delete-confirm.input-helper' | i18n: { appId: deleteConfirmIdentifier } }}
        </p>
      </div>
      <input
        nz-input
        type="text"
        [value]="deleteConfirmInput"
        (input)="onDeleteConfirmInput($any($event.target).value)"
        [placeholder]="'official.third-party-app.delete-confirm.input-placeholder' | i18n"
        [testId]="'official-third-party-delete-confirm-input'"
      />
      <p class="delete-confirm-match-hint" [class.delete-confirm-match-hint-error]="deleteConfirmInput && !deleteConfirmIdentifierMatches">
        {{ 'official.third-party-app.delete-confirm.match-hint' | i18n: { appId: deleteConfirmIdentifier } }}
      </p>
    </div>
  </ng-container>
</nz-modal>
